import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { visitorMessages } from 'src/features/visitor/utils/messages';
import { Button } from 'src/registry/ui/Button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuLabel,
    DropdownMenuTrigger,
} from 'src/registry/ui/DropdownMenu';
import { TranslationsWithId } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { cn } from 'src/utils/shadcn';

type CellStayPeriodZonesProps = {
    zonesData: TranslationsWithId[];
    className?: string;
};

const CellStayPeriodZones = ({ zonesData, className }: CellStayPeriodZonesProps) => {
    const { formatMessage, locale } = useIntl();

    const zonesLength = zonesData?.length;
    const zoneNames = zonesData.map((z) => z.translations?.find((t) => t.language === locale)?.name ?? '-').join(', ');

    const zones = zonesLength > 1 ? `${formatMessage(visitorMessages.multipleZones)}-${zonesLength}` : zoneNames;

    return (
        <>
            {zonesLength > 1 ? (
                <div className="flex flex-col gap-0 whitespace-nowrap">
                    <span className="flex flex-row items-center whitespace-nowrap">
                        <span
                            className={cn('font-medium whitespace-nowrap', className)}
                        >{`${formatMessage(visitorMessages.multipleZones)}-${zonesLength}`}</span>
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button variant="ghost" className="size-8 cursor-pointer p-0">
                                    <FontAwesomeIcon icon={ICON_MAP.ELLIPSIS} />
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="center" className="w-full min-w-[200px]">
                                <DropdownMenuLabel className="text-xs font-medium text-gray-600">
                                    {formatMessage(visitorMessages.zones)}
                                </DropdownMenuLabel>
                                <DropdownMenuGroup>
                                    {zonesData?.map((zone) => {
                                        return (
                                            <span
                                                key={zone.id}
                                                className="relative flex items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors"
                                            >
                                                {zone?.translations.find((t) => t.language === locale)?.name ?? '-'}
                                            </span>
                                        );
                                    })}
                                </DropdownMenuGroup>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </span>
                </div>
            ) : (
                <span className={cn('font-medium whitespace-nowrap', className)}>{zonesLength > 0 ? zones : '-'}</span>
            )}
        </>
    );
};

export default CellStayPeriodZones;
